import React, { useEffect, useState } from 'react'
import style from './RadioSelect.module.css'
function RadioSelect(props) {

    

    function isSelected(item){
        if(item.value===props.value)return true
        return false
    }

    return (<div className={style.grid}>
        {props.options.map((item, index) => {
          return ( <div
            key={index}
            className={style.item}
            style={isSelected(item) ? props.selectedStyle : props.notSelectedStyle}

                onClick={() => {  props.onChange(item.value); }}>
                {item.component}
            </div>)

        })}
    </div>
    )
}

export default RadioSelect